import { t } from "i18next"
import { UserAvatarTooltip } from "@/components/avatar-user-tooltip"
import { UserProvider } from "@/components/user-wrapper"
import { formatInServerTimeZone } from "@/lib/initial-time-zone"

const ConfirmedBy = ({ verifiedBy, verifiedAt }: { verifiedBy: string; verifiedAt: string }) => {
  return (
    <div className="text-on-surface-subdued mr-auto flex items-center gap-2 text-xs text-ellipsis">
      <UserProvider
        userName={verifiedBy}
        render={(user) => <UserAvatarTooltip user={user} uniqueIdentifier="last-verification" />}
      />
      <div className="grid content-center">
        <span className="text-caption text-on-surface-subdued wrap-break-word" data-test-id="confirmation-info">
          {`${t("common.confirmedOn")} ${formatInServerTimeZone(verifiedAt, "dd.MM.yyyy HH:mm")}`}
        </span>
      </div>
    </div>
  )
}

export { ConfirmedBy }
